import useGameCardSize from '~/client/shared/game/GameCard/useGameCardSize';
import GameCarousel from '~/client/shared/game/GameCarousel';
import CarouselPlaceholder from '~/client/shared/LazyLoad/Placeholder/CaroulselPlaceholder';

type Props = { type: 'highest' | 'lowest' };

const LiveRtpCarousel: FC<Props> = ({ type }) => {
  const { width, height } = useGameCardSize();
  const href = '/live-rtp';
  const titleId = `casino.${type}_rtp_games`;
  return (
    <GameCarousel
      titleId={titleId}
      href={href}
      sortBy="rtpLivePastDay"
      order={mapTypeToOrder(type)}
      subtitleId={`casino.${type}_rtp_percentage`}
      sourcePage="front_page"
      sliderName="live_rtp"
      placeholder={
        <CarouselPlaceholder
          width={width}
          height={height}
          titleId={titleId}
          href={href}
        />
      }
      light
    />
  );
};

const mapTypeToOrder = (type: Props['type']) => (type === 'highest' ? -1 : 1);

export default LiveRtpCarousel;
